import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useMenu } from "../../context/MenuContext";
import { Spinner } from "@cloudscape-design/components";

export default function ProtectedRoute({ component: Component, adminOnly, menuProtected, ...rest }) {
  const { isAuthenticated, isAdmin, loading, passwordChangeRequired } = useAuth();
  const { isMenuVisible, loading: menuLoading } = useMenu();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading || menuLoading) return <Spinner size="large" />;
        if (!isAuthenticated) return <Redirect to="/login" />;
        if (passwordChangeRequired) return <Redirect to="/change-password" />;
        if (adminOnly && !isAdmin()) return <Redirect to="/" />;
        if (menuProtected && !isAdmin() && !isMenuVisible(rest.path)) return <Redirect to="/" />;
        return <Component {...props} />;
      }}
    />
  );
}
